(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/views/layout.js') >= 0) return;  svs.modules.push('/modules/tt/views/layout.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tt=_svs.tt||{};
_svs.tt.templates=_svs.tt.templates||{};
svs.tt.templates.layout = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"tt-content\" class=\"tt-content\"></div>";
},"useData":true});
Handlebars.partials['svs-tt-layout'] = svs.tt.templates.layout;
})(svs, Handlebars);


 })(window);